import { useEffect, useRef, useState } from 'react';

/**
 * Envolve um bloco e o anima quando ele entra na viewport.
 * Se o navegador não suportar IntersectionObserver (ou nos testes),
 * o conteúdo aparece imediatamente.
 */
export default function Revelar({
  children,
  as: Tag = 'div',
  atraso = 0,
  className = '',
  ...rest
}) {
  const ref = useRef(null);
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    const elemento = ref.current;

    if (!elemento || typeof IntersectionObserver === 'undefined') {
      setVisivel(true);
      return undefined;
    }

    const observador = new IntersectionObserver(
      ([entrada]) => {
        if (entrada.isIntersecting) {
          setVisivel(true);
          observador.disconnect();
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    observador.observe(elemento);
    return () => observador.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`revelar ${visivel ? 'visivel' : ''} ${className}`.trim()}
      style={atraso ? { transitionDelay: `${atraso}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
